export const LISTAR_ANAMNESE = "LISTAR_ANAMNESE";
export const REQUEST_ANAMNESE = "REQUEST_ANAMNESE";
export const SALVAR_ANAMNESE = "SALVAR_ANAMNESE";
export const RESPOSTAS_PACIENTE = "RESPOSTAS_PACIENTE";
export const EDITAR_ANAMNESE = "EDITAR_ANAMNESE";
export const GET_ANAMNESE_ID = "GET_ANAMNESE_ID";
export const GET_ANAMNESE_PACIENTE = "GET_ANAMNESE_PACIENTE";
export const TOGGLE_ANAMNESE = "TOGGLE_ANAMNESE";
export const RESET_ANAMNESE = "RESET_ANAMNESE";
